import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "row justify-content-center"
};
const _hoisted_2 = {
  class: "col-xl-12 col-lg-12 text-white"
};
const _hoisted_3 = {
  class: "",
  style: {
    "background": "linear-gradient(52.01deg, rgb(40, 20, 74) 0%, rgb(81, 42, 150) 100%)",
    "margin-bottom": "-20px",
    "padding": "30px 0 35px 0",
    "border-top-left-radius": "1rem",
    "border-top-right-radius": "1rem"
  }
};
const _hoisted_4 = {
  class: "d-flex align-items-center pl-2"
};
const _hoisted_5 = {
  class: "col-7 col-md-7 p-0 pl-4"
};
const _hoisted_6 = {
  class: "fs-7"
};
const _hoisted_7 = {
  class: "fs-5 font-weight-bold"
};
const _hoisted_8 = {
  class: "fs-5 font-weight-bold"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-12 mt-2"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "1px",
    "width": "100%",
    "background-color": "#504a4a"
  }
})], -1);
const _hoisted_10 = {
  class: "d-flex mt-3 pl-2"
};
const _hoisted_11 = {
  class: "col-6 p-0 pl-4"
};
const _hoisted_12 = {
  class: "fw-medium fsi-14"
};
const _hoisted_13 = {
  class: "fw-extra-bold fsi-18"
};
const _hoisted_14 = {
  class: "fw-extra-bold fsi-18"
};
const _hoisted_15 = {
  class: "col-6 p-0 pl-4"
};
const _hoisted_16 = {
  class: "fw-medium fsi-14"
};
const _hoisted_17 = {
  class: "fw-extra-bold fsi-18"
};
const _hoisted_18 = {
  class: "fw-extra-bold fsi-18"
};
const _hoisted_19 = {
  class: "row justify-content-center mt-2"
};
const _hoisted_20 = {
  class: "col-12"
};
const _hoisted_21 = {
  class: "rounded shadow p-4 bg-white border-radius-20",
  style: {
    "border-radius": "1rem !important"
  }
};
const _hoisted_22 = {
  class: "row"
};
const _hoisted_23 = {
  key: 0,
  class: "row"
};
const _hoisted_24 = {
  class: "col-12 mb-3"
};
const _hoisted_25 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  const _component_i_skeleton = _resolveComponent("i-skeleton");
  const _component_RadioBtn = _resolveComponent("RadioBtn");
  const _component_Tip = _resolveComponent("Tip");
  const _component_Adjust = _resolveComponent("Adjust");
  const _component_Withdraw = _resolveComponent("Withdraw");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('farm.console.AvailableBalance')), 1), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%",
        "opacity": ".3"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_8, _toDisplayString($options.externalFormatFilPrice(_ctx.currentNode.availableBalance)), 1)]),
    _: 1
  }, 8, ["loading"])])]), _hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('farm.console.InitialPledge')), 1), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%",
        "opacity": ".3"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_14, _toDisplayString($options.externalFormatFilPrice(_ctx.currentNode.pledge, 2)), 1)]),
    _: 1
  }, 8, ["loading"])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('farm.console.LockedRewards')), 1), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%",
        "opacity": ".3"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_18, _toDisplayString($options.externalFormatFilPrice(_ctx.currentNode.lockedRewards, 2)), 1)]),
    _: 1
  }, 8, ["loading"])])])])])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", {
    class: _normalizeClass(["col-12", _ctx.role === 2 && !$data.closeTip ? 'mb-3' : 'mb-4'])
  }, [_createVNode(_component_RadioBtn, {
    theme: 2,
    disabled: _ctx.loading,
    "tab-arr": $data.tabOptions,
    modelValue: $data.optionValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.optionValue = $event)
  }, null, 8, ["disabled", "tab-arr", "modelValue"])], 2)]), _ctx.role === 2 && !$data.closeTip ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", null, [_createVNode(_component_Tip, {
    level: "warring"
  }, {
    btnGroup: _withCtx(() => [_createElementVNode("div", {
      class: "link-text-ordinary mr-2",
      onClick: _cache[1] || (_cache[1] = (...args) => $options.learnMore && $options.learnMore(...args))
    }, _toDisplayString(_ctx.$t('farm.console.learnMore')), 1), _createElementVNode("div", {
      class: "link-text-ordinary",
      onClick: _cache[2] || (_cache[2] = $event => $data.closeTip = true)
    }, _toDisplayString(_ctx.$t('farm.console.Close')), 1)]),
    default: _withCtx(() => [_createElementVNode("span", {
      innerHTML: _ctx.$t('farm.console.WarningTip')
    }, null, 8, _hoisted_25)]),
    _: 1
  })])])])) : _createCommentVNode("", true), $data.optionValue === 'Borrowing & Repayment' ? (_openBlock(), _createBlock(_component_Adjust, {
    key: 1,
    ref: "adjust",
    onUpdateInfo: $options.updateInfo,
    onApproveOperator: $options.approveOperator
  }, null, 8, ["onUpdateInfo", "onApproveOperator"])) : _createCommentVNode("", true), $data.optionValue === 'Withdraw From Node' ? (_openBlock(), _createBlock(_component_Withdraw, {
    key: 2,
    onGotoRepay: $options.gotoRepay,
    onUpdateInfo: $options.updateInfo,
    onApproveOperator: $options.approveOperator
  }, null, 8, ["onGotoRepay", "onUpdateInfo", "onApproveOperator"])) : _createCommentVNode("", true)])])])]);
}